<template>
    <div id="globalFooter" class="global-footer">
        <div class="global-footer-copyright">
            <div class="grid-container">
                <div class="copyright">
                    <a href="https://www.appfacilita.com/" target="_blank">
                        <img
                            class="copyright-image"
                            :src="require('@/Assets/Images/logos/facilita-marketplace-icon-branco.svg')"
                            alt="Facilita"
                        />
                    </a>
                    <p class="copy">
                        <span>Site gerado com o Facilita Marketplace. É corretor de Imóveis? <a href="https://appfacilita.com/marketplace" target="__blank">Clique aqui e conheça!</a></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- /.global-footer -->
</template>

<script>
    export default {}
</script>

<style lang="stylus"></style>
